import { useEffect, useState } from "react";

export const useNow = (running, interval = 1000) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!running) return undefined;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), interval);
    return () => clearInterval(timer);
  }, [running, interval]);

  return now;
};
